
import {
  DishItem,
  IngredientItem
} from "@/types/recipes";
import { defineComponent } from "vue";
import DetailIngredientItem from "./DetailIngredientItem.vue";

export default defineComponent({
  components: { DetailIngredientItem },
  name: "DetailDishItem",
  props: {
    id: {
      type: Number
    },
    ingredientType: {
      type: String
    },
    title: {
      type: String
    },
    dishItem: {
      type: DishItem
    },
    cookingTool: {
      type: String
    }
  },
  setup(props) {
    const getIngredients = () => {
      const items = Array<IngredientItem>();
      if (props.dishItem && props.dishItem.ingredients) {
        for (let i = 0; i < props.dishItem.ingredients.length; i++) {
          items.push(
            new IngredientItem(
              i,
              props.dishItem.ingredients[i],
              props.dishItem.ingredients[i].item,
              i == 0,
              i == props.dishItem.ingredients.length - 1
            )
          );
        }
      }
      return items;
    };

    const isShowCookingTool = () => {
      return props.cookingTool;
    };

    return {
      getIngredients,
      isShowCookingTool
    };
  }
});
